import { API_BASE } from './config';

export async function saveSmartPromotion(payload) {
  const res = await fetch(`${API_BASE}/smart-promotions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) {
    const error = data?.error || 'Failed to save smart promotion';
    throw new Error(error);
  }
  return data;
}

export async function reorderSmartPromotions(propertyId, updates) {
  if (!propertyId) throw new Error('propertyId is required');
  if (!Array.isArray(updates)) throw new Error('updates must be an array');

  const res = await fetch(`${API_BASE}/smart-promotions/reorder`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ propertyId, updates }),
  });
  const data = await res.json();
  if (!res.ok) {
    const error = data?.error || 'Failed to reorder smart promotions';
    throw new Error(error);
  }
  return data;
}

export async function generateSmartPromotionCopy(payload) {
  const res = await fetch(`${API_BASE}/smart-promotions/generate-copy`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload || {}),
  });
  const data = await res.json();
  if (!res.ok) {
    const error = data?.error || 'Failed to generate copy';
    throw new Error(error);
  }
  if (Array.isArray(data?.copies)) {
    return data.copies.filter(Boolean);
  }
  return data?.copy ? [data.copy] : [];
}
